// Must load first: in a "view as customer" tab it swaps in the view's login before anything reads it.
import './services/view_as/boot';
// Tells the API when someone is actually using the portal (usage tracking for Sales).
import './services/engagement/tracker';
import { rememberLanding } from './utilities/attribution';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import 'tailwindcss/tailwind.css';
import { router } from './Router';
import { RouterProvider } from 'react-router-dom';
// import App from './App';
import Analytics from 'analytics';
import googleAnalytics from '@analytics/google-analytics';
import { MaintenanceGuard } from './components/MaintenanceGuard.component';

export const analytics = Analytics({
  app: 'Dashboard',
  plugins: [
    googleAnalytics({
      measurementIds: [process.env.REACT_APP_GOOGLE_ANALYTICS_ID]
    })
  ]
});

analytics.page();
// An ad that links straight to the portal (e.g. /new-account?utm_source=...) is remembered for the sign-up form.
rememberLanding();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <MaintenanceGuard>
    <RouterProvider router={router} />
  </MaintenanceGuard>
);

